import { UploadTaskStatus } from './FilesDropZone'
import { ChevronDown, ChevronUp } from '@/assets/icons'
import { FileUploadStatusList } from './FileUploadStatusList'
import { useEffect, useRef, useState } from 'react'
import { XClose } from '@/assets/icons'
import clsx from 'clsx'

interface FileUploadStatusPopoverProps {
  expanded: boolean
  tasks: Map<string, UploadTaskStatus>
  setExpanded: (expanded: boolean) => void
}

/**
 * FileUploadStatusPopover - modified from tailwindcss-radix boilerplate
 * https://github.com/ecklf/tailwindcss-radix/blob/main/demo/components/popover.tsx
 * @param props
 * @returns
 */
const FileUploadStatusPopover = (props: FileUploadStatusPopoverProps) => {
  const { expanded, tasks, setExpanded } = props
  const [hidden, setHidden] = useState(true)

  // Scroll to the bottom of the list when tasks update
  const scrollRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (scrollRef.current) {
      const { scrollHeight } = scrollRef.current
      scrollRef.current.scrollTo({
        top: scrollHeight,
        behavior: 'smooth',
      })
    }
  }, [tasks])

  const completedTasks = Array.from(tasks.values()).filter((task) => task.complete).length

  const closePopover = (e: React.MouseEvent) => {
    e.stopPropagation()
    setHidden(true)
    setExpanded(false)
  }

  // unhide the popover when files are uploaded
  useEffect(() => {
    if (tasks.size !== 0) {
      setHidden(false)
    }
  }, [tasks])

  return (
    <div className={clsx('z-50 fixed bottom-0 right-4 inline-block text-left w-72 sm:w-96', { hidden })}>
      <div className={'overflow-hidden rounded-t-md bg-brand-neutral-50 shadow-[0_-1px_2px_0_rgba(0,0,0,0.05)] border border-brand-neutral-200 border-b-0'}>
        <div className="mb-4">
          <div className="px-5 pt-5 flex justify-between cursor-pointer" onClick={() => setExpanded(!expanded)}>
            {completedTasks} {completedTasks === 1 ? 'upload' : 'uploads'} complete
            <div className="flex items-center gap-4">
              <div>{expanded ? <ChevronDown className="w-6 h-6" /> : <ChevronUp className="w-6 h-6" />}</div>
              <button onClick={closePopover}>
                <XClose className="w-6 h-6" />
              </button>
            </div>
          </div>
          <hr className={clsx('bg-brand-neutral-200 border-0 dark:bg-brand-neutral-700', expanded ? 'h-px mt-4' : 'h-0')}></hr>

          <div className={clsx('overflow-y-scroll transition-all', expanded ? 'h-96' : 'h-0')} ref={scrollRef}>
            <div className="px-5">
              <FileUploadStatusList tasks={tasks} scrollRef={scrollRef} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export { FileUploadStatusPopover }
